import { render, staticRenderFns } from "./reportPush.vue?vue&type=template&id=22e52d5f&scoped=true&"
import script from "./reportPush.vue?vue&type=script&lang=js&"
export * from "./reportPush.vue?vue&type=script&lang=js&"
import style0 from "./reportPush.vue?vue&type=style&index=0&id=22e52d5f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e52d5f",
  null
  
)

export default component.exports